export default {
  CONSTRUCT() {
    return {
      title: 'Trellix API',
      items: []
    };
  },
  ADD_ITEM(state, item) {
    return state.update('items', items => items.push(item));
  },
  LOGOUT_REQUEST(state) {
    return state.update('items', items => ['Login']);
  }
};
